import React from 'react';

const SellerRating = ({ className, rating, includeTotal, isGood, isBad }) => {
    const formattedRating = rating.toString().replace(',', '.');
    let textClassName = '';
    if (isGood) {
        textClassName = 'text-success';
    } else if (isBad) {
        textClassName = 'text-danger';
    }
    return (
        <span
            className={`font-weight-bold ${textClassName} ${className || ''}`}>
            {Number(formattedRating).toFixed(1) +
                (includeTotal ? '\u00A0/\u00A05.0' : '')}
        </span>
    );
};
export default SellerRating;
